import { useNavigate, useLocation } from 'react-router-dom'
import { Box, Divider } from '@mui/material'
import {
  AddOutlined as AddIcon,
  BusinessOutlined as OrganizationIcon,
} from '@mui/icons-material'
import { useAuth } from '../../contexts/AuthContext'
import { useOrganizationSettings } from '../../hooks/useOrganizationSettings'
import { NavItem, SectionLabel, SidebarBrand, SidebarScrollList, UserSidebarFooter } from './sidebarPrimitives'
import GlobalProjectList from './GlobalProjectList'
import { organizationPagePath } from '../../utils/organizationSettingsNav'

export default function GlobalSidebar() {
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAuth()
  const { organizationName, canEditProjects } = useOrganizationSettings()

  const showOrgNav = user != null
  const isOrgActive =
    location.pathname.startsWith('/organization/') ||
    location.pathname.startsWith('/settings/integrations')
  const isNewProject =
    location.pathname === '/projects/new' || location.pathname.startsWith('/projects/new/')
  const organizationLabel = organizationName || 'Organization'

  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        pt: 0.5,
        pb: 1,
        px: 0,
        overflow: 'hidden',
      }}
    >
      <SidebarBrand />

      <SidebarScrollList>
        <SectionLabel label="Projects" />
        <GlobalProjectList />
        {canEditProjects ? (
        <NavItem
          text="New project"
          icon={<AddIcon />}
          active={isNewProject}
          onClick={() => navigate('/projects/new')}
        />
        ) : null}

        {showOrgNav && (
          <>
            <Divider sx={{ my: 1, borderColor: 'var(--vs-border-subtle)' }} />
            <NavItem
              text={organizationLabel}
              title={organizationLabel}
              icon={<OrganizationIcon />}
              active={isOrgActive}
              onClick={() => navigate(organizationPagePath('general'))}
            />
          </>
        )}
      </SidebarScrollList>

      <UserSidebarFooter />
    </Box>
  )
}
